import React from 'react';
import { Modal } from 'components';

const ReviewData = ({
  data,
  closeModal,
  handleStateChange,
  updateReview,
  // handleReviewImgChange,
  openIconModel
}) => {
  return (
    <div>
      <Modal
        id='NotificationModal'
        className='appconnectmodal appgooglemodal'
        title=''
        content={
          <div className="modal-body ">
            <div className="modal-app-content">
              <form className="app-connect app-connect-google">
                {/* Message */}
                <div className="nf-group-input mt-25">
                  <label>Caption Text</label>
                  <input
                    type="text"
                    name="cptntxt"
                    className="nf-input"
                    id=""
                    placeholder="Message"
                    value={data.cptntxt}
                    onChange={handleStateChange}
                  />
                </div>
                {/* Product URL */}
                <div className="nf-group-input mt-25">
                  <label>Website Link</label>
                  <input
                    type="text"
                    name="wbstlnk"
                    className="nf-input"
                    id=""
                    placeholder="Product URL"
                    value={data.wbstlnk}
                    onChange={handleStateChange}
                  />
                </div>
                {/* Review Image */}
                <div className="nf-group-input mt-25">
                  {/* <input
                    type="file"
                    name="piu"
                    className="nf-input"
                    id="review_img_upload"
                    placeholder="Product Image"
                    value={data.piu}
                    onChange={(e) => handleReviewImgChange(e.target.files[0], data.fuid)}
                  /> */}
                  <button type='button' className="nf-btn  nf-btn-primary"
                    onClick={() => openIconModel(data.fuid)}>
                    Upload Image
                  </button>
                </div>
                <div className="nf-btn-login mt-10">
                  <button type='button' className="nf-btn  nf-btn-primary"
                    onClick={() => updateReview(data.fuid)}>
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        }
        openCloseModal={() => closeModal()}
        style={
          {
            modalStyle: {
              display: data.openCloseData ? 'block' : 'none',
              opacity: data.openCloseData ? 1 : 0
            },
            alignModalStyle: {
              top: '100px'
            }
          }
        }
      />
    </div>
  );
};

export default ReviewData;


// WEBPACK FOOTER //
// ./src/components/ReviewData/ReviewData.js